import { Icon } from "@mui/material";
import React from "react";

const CustomIcon = ({ icon = "hotel", className = "", ...rest }) => {
  return (
    <Icon className={`${className} icon`} {...rest}>
      <img style={{ height: "100%" }} src={require(`assets/icons/${icon}.svg`)} className="icon-img" alt="icon" />
    </Icon>
  );
};

export default CustomIcon;
